import { cn } from "~/common/cn"

export const PageLayout: React.FC<{
  title: React.ReactNode
  actions?: React.ReactNode
  children?: React.ReactNode
}> = ({ title, actions, children }) => (
  <div className="flex flex-1 flex-col overflow-x-auto">
    <header
      className={cn(
        "flex min-h-20 items-center justify-between gap-4 border-b bg-card/80 px-4 py-4 sm:px-8"
      )}
    >
      <h1 className="truncate text-xl font-semibold tracking-tight">{title}</h1>
      {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
    </header>
    <div className="mx-auto w-full max-w-[1440px] px-4 py-7 sm:px-8 sm:py-9">{children}</div>
  </div>
)
